import Error from 'components/error'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import { useState } from 'react'
import RequestTimeForm from '../RequestTimeForm'
import SelectTimeLayout from './select-time-layout'
import SelectTimeSkeleton from '../SelectLessonTime/select-time-skeleton'
import { useMonthlyLessonAvailability } from '../SelectLessonTime/utils'

const SelectLessonTimeRefresh = ({
  currentUrl,
  previousUrl,
  locationId,
  lessonTypeId,
  lessonCreditBalanceQuantity,
}) => {
  const [flagCanRequestTime] = useFeatureFlags([flags.FLAG_FEAT_REQUEST_TIME])
  const { data, loading, error, refetch } = useMonthlyLessonAvailability(
    locationId,
    lessonTypeId,
  )
  const [showRequestTime, setShowRequestTime] = useState(false)

  if (error) return <Error error={error} />
  if (loading) return <SelectTimeSkeleton />

  const { lessonTypes } = data
  const coach = lessonTypes[0].coach

  if (showRequestTime) {
    return (
      <RequestTimeForm
        coach={coach}
        goBackLabel="Back"
        goBackHandler={() => {
          setShowRequestTime(false)
        }}
        source="MYPGA_SCHEDULE_FULLY_BOOKED"
      />
    )
  }

  return (
    <SelectTimeLayout
      lessonTypes={lessonTypes}
      currentUrl={currentUrl}
      previousUrl={previousUrl}
      refetch={refetch}
      setShowRequestTime={
        flagCanRequestTime && coach.coachProfile ? setShowRequestTime : false
      }
      lessonCreditBalanceQuantity={lessonCreditBalanceQuantity}
    />
  )
}

export default SelectLessonTimeRefresh
